export default __webpack_public_path__ + "static/media/2.9.43175fbb.mp3";